import React, { createContext, useContext, useState, ReactNode } from 'react'
import { noop } from 'lodash'
import { PaymentMethodType } from './types'

// Create a context
interface PaymentContextType {
  paymentMethods: PaymentMethodType[] | null
  editPayment: (data: PaymentMethodType[]) => void
  setCurrentPaymentMethod: React.Dispatch<React.SetStateAction<number>>
  currentPaymentMethod: number
  product: any
  setProduct: any
  purchase: any
  setPurchase: any
  coupon: string
  setCoupon: any
  couponApplyButtonId: string
  setCouponApplyButtonId: React.Dispatch<React.SetStateAction<string>>
  couponApplyCallback: () => void
  setCouponApplyCallback: React.Dispatch<React.SetStateAction<() => void>>
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined)

// Create a provider component
interface PaymentProviderProps {
  children: ReactNode
}

export const PaymentProvider: React.FC<PaymentProviderProps> = ({ children }) => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodType[] | null>(null)
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState(0)
  const [product, setProduct] = useState({})
  const [purchase, setPurchase] = useState(null)
  const [coupon, setCoupon] = useState('')
  const [couponApplyCallback, setCouponApplyCallback] = useState(() => noop)
  const [couponApplyButtonId, setCouponApplyButtonId] = useState('')
  const editPayment = (data: PaymentMethodType[]) => {
    setPaymentMethods(data)
  }

  return (
    <PaymentContext.Provider
      value={{
        paymentMethods,
        editPayment,
        currentPaymentMethod,
        setCurrentPaymentMethod,
        product,
        setProduct,
        purchase,
        setPurchase,
        coupon,
        setCoupon,
        couponApplyCallback,
        setCouponApplyCallback,
        couponApplyButtonId,
        setCouponApplyButtonId
      }}
    >
      {children}
    </PaymentContext.Provider>
  )
}

// Custom hook to use the context
export const usePaymentContext = (): PaymentContextType => {
  const context = useContext(PaymentContext)
  if (!context) {
    throw new Error('usePaymentContext must be used within a PaymentProvider')
  }
  return context
}
